import React, { useState, useEffect } from "react"
import { CardText, Col, Row, Alert, Label } from "reactstrap"

import DPTextBox from "../../../framework/components/DPTextBox"
import DPSwitch from 'framework/components/DPSwitch'
import DPDropDown from "framework/components/DPDropDown"
import DPAniversaryBox from "framework/components/DPAniversaryBox"
//import { DatePicker } from 'rsuite';

const CustomerMasterTab4 = ({
  fieldManager,
  GenderValue,
  GenderOnChange,
  DOBValue,
  DOBOnChange,
  MarriedValue,
  MarriedOnChange,
  SNameValue,
  SNameOnChange,
  SDOBVlaue,
  SDOBOnChange,
  ProValue,
  ProOnChange,
  DesigValue,
  DesigOnChange,
  CompVlaue,
  CompOnChange,
  ReliValue,
  ReliOnChange,
  EthnValue,
  EthnOnChange,
  Disabled,
  show,
  AlertMsg,
  AlertColor,
  genDOB,
  mmValue,
  mmOnchange,
  mmOnBlur,
  ddValue,
  ddOnChange,
  ddOnBlur
}) => {

  const [company, SetCompany] = useState([])
  const [profession, SetProfession] = useState([])
  const [designation, SetDesignation] = useState([])
  const [religion, SetReligion] = useState([])
  const [ethnicity, SetEthnicity] = useState([])

  const a = "F"

  useEffect(() => {
    const authToken = localStorage.getItem("authToken")
    /**************get designation data */
    function getDesignation() {
      var requestOptions = {
        method: 'GET',
        headers: {
          "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
      };
      const ApiURL = window.Links.ApiURL
      fetch(`${ApiURL}Designation/Select/`, requestOptions)
        .then(response => response.json())
        .then(result => {
          SetDesignation(result.data)
          let dt = result.data
        }).catch(error => console.log('error', error));
    }
    /**************get designation data  End*/

    /**************get Religion data */
    function getReligion() {
      var requestOptions = {
        method: 'GET',
        headers: {
          "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
      };
      const ApiURL = window.Links.ApiURL
      fetch(`${ApiURL}Religion/Select/`, requestOptions)
        .then(response => response.json())
        .then(result => {
          SetReligion(result.data)
          let dt = result.data
        }).catch(error => console.log('error', error));
    }
    /**************get designation data End*/

    /**************get Ethnicity data */
    function getEthnicity() {
      var requestOptions = {
        method: 'GET',
        headers: {
          "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
      };
      const ApiURL = window.Links.ApiURL
      fetch(`${ApiURL}Ethnicity/Select/`, requestOptions)
        .then(response => response.json())
        .then(result => {
          SetEthnicity(result.data)
          let dt = result.data

        }).catch(error => console.log('error', error));
    }
    /**************get designation data End*/

    /**************get company data */
    function getCompany() {
      var requestOptions = {
        method: 'GET',
        headers: {
          "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
      };
      const ApiURL = window.Links.ApiURL
      fetch(`${ApiURL}Company/Select/`, requestOptions)
        .then(response => response.json())
        .then(result => {
          SetCompany(result.data)
          let dt = result.data
        }).catch(error => console.log('error', error));
    }
    /**************get company data End*/

    /**************get profession data */
    function getProfession() {
      var requestOptions = {
        method: 'GET',
        headers: {
          "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
      };
      const ApiURL = window.Links.ApiURL
      fetch(`${ApiURL}profession/Select/`, requestOptions)
        .then(response => response.json())
        .then(result => {
          SetProfession(result.data)
          let dt = result.data
        }).catch(error => console.log('error', error));
    }
    /**************get profession data End*/
    getDesignation()
    getReligion()
    getEthnicity()
    getCompany()
    getProfession()
  }, []);

  const genderTable = [{ label: "Male", value: "M" }, { label: "Female", value: "F" }, { label: "Unassign", value: "U" }]

  const ranges = [
    {
      label: 'Now',
      value: new Date()
    }
  ]

  return (
    <React.Fragment>
      <div>
        <Row>
          <Col sm="12">
            <CardText className="mb-0">
              <Row>
                {show ? (
                  <Alert color={AlertColor} role="alert">
                    {AlertMsg}
                  </Alert>
                ) : null}
                <Col sm={12} md={6} className="mb-5-sm">

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_GENDER')}>
                    <DPDropDown
                      labelText="Gender"
                      rowClass="mb-4-sm"
                      optionGroup={genderTable}
                      selectedGroup={GenderValue}
                      onChange={GenderOnChange}
                      disabled={Disabled == true ? Disabled : genDOB || fieldManager.disable.includes('CM_GENDER')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_DOB')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Date Of Birth"
                      textType="date"
                      value={DOBValue}
                      onChange={DOBOnChange}
                      disabled={Disabled == true ? Disabled : genDOB || fieldManager.disable.includes('CM_DOB')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_CIVILSTAT')}>
                    <Row>
                      <Col sm={3}>         <Label
                        htmlFor="example-text-input"
                        className={`col-md-12 col-form-label-sm`}
                      >
                        Married
                      </Label></Col>
                      <Col >
                        <DPSwitch
                          rowClass={"mb-4-sm"}
                          onChange={MarriedOnChange}
                          checked={MarriedValue}
                          disabled={Disabled || fieldManager.disable.includes('CM_CIVILSTAT')}
                        />
                      </Col>
                    </Row>
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_SPOUSE')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Spouse Name"
                      textType="text"
                      defaultValue=""
                      textAlign="left"
                      value={SNameValue}
                      onChange={SNameOnChange}
                      disabled={Disabled || fieldManager.disable.includes('CM_SPOUSE')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_SPDOB')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Spouse's DOB"
                      textType="date"
                      value={SDOBVlaue}
                      onChange={SDOBOnChange}
                      disabled={Disabled || fieldManager.disable.includes('CM_SPDOB')}
                    />
                  </div>

                  {/* <DPTextBox
                    rowClass="mb-4-sm"
                    labelText="Wedding Anniversary"
                    textType="date"
                    value={WedValue}
                    onChange={WedOnChange}
                    disabled={Disabled}
                  /> */}

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_ANNIVERSARY')}>
                    <DPAniversaryBox
                      rowClass="mb-4-sm"
                      labelText="Wedding Anniversary"
                      textType="text"
                      mmplaceholder="mm"
                      mmValue={mmValue}
                      mmonChange={mmOnchange}
                      mmonBlur={mmOnBlur}
                      ddplaceholder="dd"
                      ddvalue={ddValue}
                      ddonChange={ddOnChange}
                      ddonBlur={ddOnBlur}
                      disabled={Disabled || fieldManager.disable.includes('CM_ANNIVERSARY')}
                      textAlign="right"
                    />
                  </div>
                  {/* <DatePicker format="MM DD" showMeridian ranges={ranges} /> */}

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_PROFESSION')}>
                    <DPDropDown
                      labelText="Profession"
                      rowClass="mb-4-sm"
                      optionGroup={profession}
                      selectedGroup={ProValue}
                      onChange={ProOnChange}
                      disabled={Disabled || fieldManager.disable.includes('CM_PROFESSION')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_DESIGNATION')}>
                    <DPDropDown
                      labelText="Designation"
                      rowClass="mb-4-sm"
                      optionGroup={designation}
                      selectedGroup={DesigValue}
                      onChange={DesigOnChange}
                      disabled={Disabled || fieldManager.disable.includes('CM_DESIGNATION')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_COMPANY')}>
                    <DPDropDown
                      labelText="Company"
                      rowClass="mb-4-sm"
                      optionGroup={company}
                      selectedGroup={CompVlaue}
                      onChange={CompOnChange}
                      disabled={Disabled || fieldManager.disable.includes('CM_COMPANY')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_RELIGION')}>
                    <DPDropDown
                      labelText="Festival Preference"
                      rowClass="mb-4-sm"
                      optionGroup={religion}
                      selectedGroup={ReliValue}
                      onChange={ReliOnChange}
                      disabled={Disabled || fieldManager.disable.includes('CM_RELIGION')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_ETHNICITY')}>
                    <DPDropDown
                      labelText="Ethnicity"
                      rowClass="mb-4-sm"
                      optionGroup={ethnicity}
                      selectedGroup={EthnValue}
                      onChange={EthnOnChange}
                      disabled={Disabled || fieldManager.disable.includes('CM_ETHNICITY')}
                    />
                  </div>
                </Col>
              </Row>
            </CardText>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}
export default CustomerMasterTab4
